import React, { useEffect, useRef } from 'react';
import './ClickOutside.scss';

const ClickOutside = ({ children, onClickOutside }) => {
	const wrapperRef = useRef(null);

	useEffect(() => {
		const handleClick = e => {
			if (!wrapperRef?.current.contains(e.target)) onClickOutside?.(e);
		};

		document.addEventListener('mousedown', handleClick);

		return () => document.removeEventListener('mousedown', handleClick);
	}, [onClickOutside]);

	return (
		<div className='ClickOutside' ref={wrapperRef}>
			{children}
		</div>
	);
};

export default ClickOutside;
